import { useToggle } from '@bygghemmait/hooks';
import React from 'react';
import { useSelector } from 'react-redux';
import {
  getDetailedMeta,
  getProductTitle,
  isPurchasable,
  selectShouldUseNotifyMe
} from 'views/ProductPage/selector';
import { rm } from 'utils';
import { NotifyMeModal } from './NotifyMeModal';
import Modal from 'components/Shared/Modal';
import { PageState } from 'models/PageState';
import { NotifyMeButton } from './NotifyMeButton';
import { StyledButton } from './notifyMe.styles';

export const NotifyMe = () => {
  const [showModal, toggleModal] = useToggle(false);
  const [showSuccessModal, toggleSuccessModal] = useToggle(false);
  const productTitle = useSelector(({ currentPage }: PageState) => getProductTitle(currentPage));

  const purchasable = useSelector(isPurchasable);
  const shouldUseNotifyMe = useSelector(selectShouldUseNotifyMe);
  const meta = useSelector(getDetailedMeta);
  if (purchasable || !shouldUseNotifyMe || meta?.isBackOrder) {
    return null;
  }

  return (
    <>
      <NotifyMeButton onClick={toggleModal} />
      <NotifyMeModal
        show={showModal}
        onClose={toggleModal}
        onSuccess={toggleSuccessModal}
        productTitle={productTitle}
      />
      <SuccessModal
        show={showSuccessModal}
        onClose={toggleSuccessModal}
        productTitle={productTitle}
      />
    </>
  );
};

type SuccessModalProps = {
  show: boolean;
  onClose: () => void;
  productTitle: string;
};

const SuccessModal = ({ show, onClose, productTitle }: SuccessModalProps) => {
  return (
    <Modal show={show} onClose={onClose}>
      <h2>{rm('notify-me-success-header', productTitle)}</h2>
      <p>{rm('notify-me-success-text')}</p>
      <StyledButton onClick={onClose} appearance="whitePill">
        {rm('Shared_Button_Close')}
      </StyledButton>
    </Modal>
  );
};
